import { create } from 'zustand';

const useImportDocumentStore = create((set) => ({
  selectedBorrower: null,
  selectedCoborrower: null,
  selectedAgent: null,
  selectedCarrier: null,
  selectedBroker: null,
  importDocumentChanges: [],

  setSelectedBorrower: (borrower) => set({ selectedBorrower: borrower }),
  setSelectedCoborrower: (coborrower) =>
    set({ selectedCoborrower: coborrower }),
  setSelectedAgent: (agent) => set({ selectedAgent: agent }),
  setSelectedCarrier: (carrier) => set({ selectedCarrier: carrier }),
  setSelectedBroker: (broker) => set({ selectedBroker: broker }),

  setImportDocumentChanges: (changes) =>
    set({ importDocumentChanges: changes }),
}));

export default useImportDocumentStore;
